import { CRUDApiService } from "./CRUDApiService";

export class CategoryApiService extends CRUDApiService {
  constructor() {
    super('categories');
  }
}
